import { useMutation } from '@tanstack/react-query'
import { t } from 'i18next'

import type { TCriarPropostaResponse, TPropostaData } from '@/features/proposta/interfaces/proposta.type'
import { CriarProposta } from '@/features/proposta/services/criar-proposta.service'
import type { AxiosErrorMap } from '@/infra/http'
import { showToast } from '@/infra/sonner'
import { regexParaCodigoProduto } from '@/utils/regex'

const PRODUTO_INDISPONIVEL = 'PRODUCT_UNAVAILABLE'
const VAGA_PADRAO_INDISPONIVEL = 'STANDARD_PARKING_UNAVAILABLE'

export const useCriarProposta = () => {
  return useMutation<TCriarPropostaResponse, AxiosErrorMap, TPropostaData>({
    mutationFn: (proposta: TPropostaData) => new CriarProposta().execute(proposta),
    onSuccess: () => {
      showToast({
        message: t('proposta:sucesso'),
        variant: 'success',
      })
    },
    onError: (error) => {
      const erroProdutoIndisponivel = error?.response?.data?.find((e) => e.code === PRODUTO_INDISPONIVEL)
      const erroVagaPadraoIndisponivel = error?.response?.data?.find((e) => e.code === VAGA_PADRAO_INDISPONIVEL)
      if (erroProdutoIndisponivel) {
        const codigoProduto = regexParaCodigoProduto.exec(erroProdutoIndisponivel.message)?.[1]
        showToast({
          message: t('proposta:erros.produto_indisponivel', { code: codigoProduto ?? '' }),
          variant: 'error',
        })
        return
      }

      if (erroVagaPadraoIndisponivel) {
        showToast({
          message: t('proposta:erros.vaga_padrao_indisponivel'),
          variant: 'error',
        })
        return
      }

      showToast({
        message: t('common:errors_gerais.padrao'),
        variant: 'error',
      })
    },
  })
}
